module.exports = __webpack_public_path__ + "img/stock2.36da9650.png";